export const getMessage = (message: any, language?: string, fallback = "Success") => {
  if (!message) return fallback;
  if (typeof message === "string") return message;

  return message[language ?? "en"] ?? message.en ?? message.vi ?? fallback;
};
